import React from 'react'
import { Link } from 'react-router-dom'

import './css/SubNavbar.css'

export default class SubNavbar extends React.Component {
  render() {
    return (
      <div className="sub-navbar-container">
        <Link to="/">
          <div className="logo-mobile sub-nav-logo" />
        </Link>
        <div className="subnavbar-items">
          <Link to="/">
            <div className="subnavbar-item">HOME</div>
          </Link>
          <Link to="/about">
            <div className="subnavbar-item">ABOUT</div>
          </Link>
          <Link to="/how">
            <div className="subnavbar-item">HOW IT WORKS</div>
          </Link>
          <Link to="/invite">
            <div className="subnavbar-item">GET THE INVITE</div>
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/SubNavbar.js